/* context

*/
import * as mathHelper from "../mathHelper.js";
import { CanvasElement } from "./CanvasElement.js";

export class ImageCanvasElement extends CanvasElement {
  element;

  constructor(resource, element, is_invalidating_draw = true) {
    super(resource, is_invalidating_draw);
    this.element = element;
  }

  clip_image_round_cornders(corner_radius_array, icanvas, draw_rect_array) {
    if (corner_radius_array == undefined) {
      return;
    }
    // https://stackoverflow.com/questions/19585999/canvas-drawimage-with-round-corners

    var x = draw_rect_array[0];
    var y = draw_rect_array[1];
    icanvas.ctx.beginPath();
    icanvas.ctx.moveTo(x + corner_radius_array[0], y);
    icanvas.ctx.lineTo(x + draw_rect_array[2] - corner_radius_array[0], y);
    icanvas.ctx.quadraticCurveTo(x + draw_rect_array[2], y, x + draw_rect_array[2], y + corner_radius_array[0]);
    icanvas.ctx.lineTo(x + draw_rect_array[2], y + draw_rect_array[3] - corner_radius_array[1]);
    icanvas.ctx.quadraticCurveTo(x + draw_rect_array[2], y + draw_rect_array[3], x + draw_rect_array[2] - corner_radius_array[1], y + draw_rect_array[3]);
    icanvas.ctx.lineTo(x + corner_radius_array[2], y + draw_rect_array[3]);
    icanvas.ctx.quadraticCurveTo(x, y + draw_rect_array[3], x, y + draw_rect_array[3] - corner_radius_array[2]);
    icanvas.ctx.lineTo(x, y + corner_radius_array[3]);
    icanvas.ctx.quadraticCurveTo(x, y, x + corner_radius_array[3], y);
    icanvas.ctx.closePath();
    icanvas.ctx.clip();
  }

  draw(icanvas) {
    if (this.resource.isLoading()) {
      return;
    }

    let image_rect = this.resource.toRect(icanvas);

    let drawOffsetX = 0;
    let drawOffsetY = 0;

    icanvas.ctx.save();

    var corner_radius_array;
    if (this.resource.corner_radius) {
      if (Array.isArray(this.resource.corner_radius)) {
        corner_radius_array = this.resource.corner_radius;
      } else if (typeof this.resource.corner_radius === 'number') {
        corner_radius_array = [this.resource.corner_radius, this.resource.corner_radius, this.resource.corner_radius, this.resource.corner_radius]
      }
    }

    if (this.resource.centerRotateDegrees) {
      // https://stackoverflow.com/questions/3793397/html5-canvas-drawimage-with-at-an-angle
      let r = mathHelper.degreesToRadians(this.resource.centerRotateDegrees);

      icanvas.ctx.translate(image_rect.p.x + image_rect.w / 2, image_rect.p.y + image_rect.h / 2);

      icanvas.ctx.rotate(r);
      drawOffsetX = -image_rect.w / 2;
      drawOffsetY = -image_rect.h / 2;
    } else {
      drawOffsetX = image_rect.p.x;
      drawOffsetY = image_rect.p.y;
    }

    this.width = image_rect.w;
    this.height = image_rect.h;

    var draw_rect_array = [drawOffsetX, drawOffsetY, image_rect.w, image_rect.h]

    if (this.resource.isError) {
      icanvas.ctx.rect(draw_rect_array[0], draw_rect_array[1], draw_rect_array[2], draw_rect_array[3]);
    } else {
      icanvas.draw_log.push({message:"image", details:this.element.currentSrc?.split('/').pop()});
      //console.log("visual:image:draw:" + this.element.currentSrc);
      this.clip_image_round_cornders(corner_radius_array, icanvas, draw_rect_array);
      icanvas.ctx.drawImage(this.element, draw_rect_array[0], draw_rect_array[1], draw_rect_array[2], draw_rect_array[3]);
    }

    icanvas.ctx.restore();
  }
}
